import { SioFestFloatingButton } from '@/components/siofest-floating-button';
import { Link } from '@inertiajs/react';

function Footer() {
    return (
        <>
            <div className="mt-8">
                <footer className="footer footer-horizontal footer-center border border-gray-700 bg-base-100 text-base-content rounded py-8 md:p-10">
                    <nav className="gap-4 md:grid md:grid-flow-col">
                        <Link href={route('privacy')} className="link link-hover">
                            プライバシーポリシー
                        </Link>
                        <Link href={route('umimachi')} className="link link-hover">
                            会社概要
                        </Link>
                        <Link href={route('personality')} className="link link-hover">
                            出演者紹介
                        </Link>
                    </nav>
                    <aside>
                        <p>Copyright © - All right reserved by LLP Umimachi Garage</p>
                    </aside>
                </footer>
            </div>
            <SioFestFloatingButton />
        </>
    );
}

export default Footer;
